import $ from 'jquery';

export const maxSmallScreenSize = 767;

export function isSmallScreen(): boolean {
  return window.innerWidth < maxSmallScreenSize;
}

export type ScreenSizeHandlers = {
  onChangeToSmall?: () => void,
  onChangeToLarge?: () => void,
};

export function handleScreenSizes(handlers: ScreenSizeHandlers) {
  let lastSize = window.innerWidth <= maxSmallScreenSize ? 'xs' : 'other';

  $(window).on('id7:reflow', (event, screenSize) => {
    const currentSize = screenSize.name;
    if (handlers.onChangeToLarge !== undefined && currentSize !== 'xs' && lastSize === 'xs') {
      handlers.onChangeToLarge();
    }
    if (handlers.onChangeToSmall !== undefined && currentSize ==='xs' && lastSize !== 'xs') {
      handlers.onChangeToSmall();
    }
    lastSize = screenSize.name;
  });
}
